import React from 'react'
import './index.css';


export default function SelectIconButton({ isActive, icon, activeIcon, text, description, handleClick }) {
    return (
        <div onClick={handleClick} className={`lover-switch-button  ${isActive ? 'lover-switch-button-active' : null}`}>
            <img src={isActive ? require(`../../../assets/icons/${activeIcon}`) : require(`../../../assets/icons/${icon}`)} />
            <p>{text}</p>
            <p>{description}</p>
        </div>
    )
}
